import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import ProfileRegistration from "../pages/dashboard/ProfileRegistration";

// components
import Layout from "./Layout";

// pages
import Error from "../pages/error";
import Home from "../pages/home";
import Privacy from "../pages/dashboard/Privacy"
import ShilparamPrivacy from "../pages/dashboard/ShilparamPrivacy"
import Success from "../pages/dashboard/Success";
import Getqr from "../pages/dashboard/Getqr";
// context
import { useUserState } from "../context/UserContext";
// import SchoolRegistration from "../pages/dashboard/SchoolRegistration";
import TicketBooking from "../pages/dashboard/TicketBooking";
import DoctorBooking from "../pages/dashboard/DoctorBooking";
import ExbhitionBooking from "../pages/dashboard/ExbhitionBooking";
import Appointment from "../pages/dashboard/Appointment";
import LoanAppointment from "../pages/dashboard/loanAppointment";
import ExbhitionAppointment from "../pages/dashboard/exbhitionAppoitment";
import LoanBooking from "../pages/dashboard/LoanBooking";
import CoachingBooking from "../pages/dashboard/CoachingBooking";
import LoginLayout from "./LoginLayout/LoginLayout";
import Events from "../pages/home/Events";
import EventDetails from "../pages/home/EventDetails";
import EventBooking from "../pages/home/EventBooking";
import Login from "../pages/login/Login";
import CounterLogin from "../pages/login/CounterLogin";
import InspectorLogin from "../pages/login/InspectorLogin";
import TermsConditions from "../pages/dashboard/TermsConditions";
import RefundPolicy from "../pages/dashboard/RefundPolicy";
import PrivacyPolicy from "../pages/dashboard/PrivacyPolicy";
// import ProfileRegistration from "../pages/dashboard/ProfileRegistration";
// import Login from "../pages/login/Login";
// import CounterLogin from "../pages/login/CounterLogin";
// import InspectorLogin from "../pages/login/InspectorLogin";
// import TermsConditions from "../pages/dashboard/TermsConditions";
// import RefundPolicy from "../pages/dashboard/RefundPolicy";
// import PrivacyPolicy from "../pages/dashboard/PrivacyPolicy";
// import ProfileRegistration from "../pages/dashboard/ProfileRegistration";

export default function App() {
  // global
  var { isAuthenticated } = useUserState();

  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/home" />} />
        {/* <Route
          exact
          path="/app"
          render={() => <Redirect to="/app/success" />}
        /> */}
       
        <PublicRoute path="/ticketbooking/:parkId" component={TicketBooking} />
        <PublicRoute path="/doctorbooking/:doctorId" component={DoctorBooking} />
        <PublicRoute path="/exbhitionbooking/:exbhitionId" component={ExbhitionBooking} />
        <PublicRoute path="/exbhitionappointment/:appointmentId/:exbhitionId" component={ExbhitionAppointment} />
        <PublicRoute path="/doctorappointment/:appointmentId/:clinicId" component={Appointment} />
        <PublicRoute path="/loanbooking/:branchuserId" component={LoanBooking} />
        <PublicRoute path="/loanappointment/:bookingId/:branchId" component={LoanAppointment} />

        <PublicRoute path="/coachingbooking/:coachingId" component={CoachingBooking} />
        <PublicRoute path="/getqr/:parkId" component={Getqr} />
        {/* <PublicRoute path="/login" component={Login} /> */}
        <PublicRoute path="/home" component={Home} />
        <PublicRoute path="/events" component={Events} />
        <PublicRoute path="/event/:id/booking" component={EventBooking} />
        <PublicRoute path="/event/:id" component={EventDetails} />
        <Route path="/privacy-policy" component={Privacy} />
        <Route path="/privacypolicy" component={ShilparamPrivacy} />
        <PublicRoute path="/paymentstatus/:bookingId/:parkId" component={Success} />
        <PrivateRoute path="/app" component={Layout} />
        {/* <Route path="/sriqr/profileregistration" component={ProfileRegistration} /> */}

        {/* Login and Registration Routes */}
        <PublicRoute path="/login" component={Login} />
        <PublicRoute path="/profileregistration" component={ProfileRegistration} />
        <PublicRoute path="/branchuser" component={CounterLogin} />
        <PublicRoute path="/inspectorlogin" component={InspectorLogin} />
        <PublicRoute path="/termsconditions" component={TermsConditions} />
        <PublicRoute path="/refundpolicy" component={RefundPolicy} />
        <PublicRoute path="/privacypolicy" component={PrivacyPolicy} />

        <PublicRoute path="/sriqr" component={LoginLayout} />
        
        <Route component={Error} />
      </Switch>
    </HashRouter>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          React.createElement(component, props)
        }
      />
    );
  }
}
